import { saveTextFile } from './app-platform.js'
import { isNativeApp } from './native-session.js'

/**
 * Saving a text artifact the person asked for — the diagnostics bundle, the account export.
 * The DOM is reached through a narrow shape so this works under a test runner with no document:
 * with no document there is nothing to hand a file to, and the caller still reports what it did.
 */
export function downloadText(filename: string, text: string): void {
  // The installed app cannot download; the native share sheet saves the file instead.
  if (isNativeApp()) {
    void saveTextFile(filename, text)
    return
  }
  const documentLike = globalThis as unknown as {
    document?: {
      createElement(tag: string): { href: string; download: string; click(): void }
    }
  }
  const document = documentLike.document
  if (document === undefined) return
  const blob = new Blob([text], { type: 'application/json' })
  const anchor = document.createElement('a')
  anchor.href = URL.createObjectURL(blob)
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(anchor.href)
}
